import { AdminComponent } from '~/components/admin-component/admin-component';

export const Genders = () => (
  <AdminComponent
    componentName="Genders"
    title="Genders"
  />
);
